import React from "react";
import BannerAds from "../../Shared/BannerAds/BannerAds";
import ViewProducts from "../ViewProducts.jsx/ViewProducts";
import { products } from "../../../data/products";

const Ads = () => {
  return (
    <div className="grow">
      <ViewProducts title="Featured Vehicle Ads" products={products} />
      <BannerAds />
      <ViewProducts title="Category Ads" products={products} />
      <BannerAds />
    </div>
  );
};

export default Ads;
